
export function groupComments(comments: any[]) {
  return comments.reduce((acc: any, comment: any) => {
    if (!comment.parent_id) {
      if (!acc[comment.id]) {
        acc[comment.id] = {
          ...comment,
          replies: []
        };
      } else {
        acc[comment.id] = {
          ...comment,
          replies: [...acc[comment.id].replies]
        };
      }
    } else {
      const parentComment = acc[comment.parent_id];
      if (parentComment) {
        parentComment.replies.push(comment);
      }
    }
    return acc;
  }, {});
}
